import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import Text from '../../../../Text';

export const ResponseLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ResponseLabel = styled(Text)`
  font-size: 14px;
  color: ${themeGet('colors.black.80')};
  margin: 0 3px 8px;
`;
